<form [formGroup]="primaryForm" (ngSubmit)="create()">
    <div class="card">
        <div class="card-header text-center" style="text-transform: uppercase;">NUEVA DEPENDENCIA</div>
        <div class="card-body">
            <div class="row gx-3 mb-3">
                <div class="col-md-12">
                    <label class="small mb-1" for="name">Razón social (50 max.)</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="name">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
                        <input (keyup)="onFormatRut($event)" type="text" class="form-control" formControlName="rut">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="location">Ubicación</label>
                    <input type="text" class="form-control" formControlName="location">
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="rut">INSTALACIÓN</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1"><i
                                class="fa-solid fa-map-location"></i></span>
                        <select class="form-select" formControlName="facility_id">
                            <option value="0">SELECCIONE</option>
                            <option *ngFor="let item of facilitys" [value]="item?.id">{{item?.name}}
                            </option>
                        </select>
                        <button (click)="openModal(addFacility,'sm')" class="btn btn-outline-secondary"
                            type="button"><i class="fa-solid fa-plus"></i></button>
                    </div>
                </div>
                <div class="col-md-12 mb-2 alert alert-warning">
                    <label class="small mb-1" for="hide_rounds">AJUSTES</label>
                    <div class="form-check form-switch ms-4">
                        <input class="form-check-input"   type="checkbox" (change)="hideRounds($event)" role="switch" id="hide_rounds" 
                        [checked]="primaryForm.get('hide_rounds')?.value==1">
                        <label class="form-check-label" for="hide_rounds">Ocultar rondas</label>
                      </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="name">Propietario/Gerente (50 max.)</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="owner">
                    </div>
                </div>
                <div class="col-md-12">
                    <label class="small mb-1" for="name">Telefono Propietario/Gerente</label>
                    <div class="input-group">
                        <input type="text" class="form-control text-capitalize" formControlName="owner_phone">
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="email">Email</label>
                    <div class="input-group flex-nowrap">
                        <span class="input-group-text" id="addon-wrapping"><i class="fa-regular fa-envelope"></i></span>
                        <input type="email" class="form-control" placeholder="Email  contacto" formControlName="email">
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <label class="small mb-1" for="phone">Tel.</label>
                    <div class="input-group flex-nowrap">
                        <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i></span>
                        <input type="email" class="form-control" placeholder="Telefono contacto" formControlName="phone">
                    </div>
                </div>
            </div>
            <button class="btn btn-primary w-100" type="submit">CREAR</button>
        </div>
    </div>
</form>
<ng-template #addFacility let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-facility [refModal]="modalRef" (success)="getFacility(); primaryForm.get('facility_id')?.setValue($event)" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
